(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-video"] && !Shopify.designMode) return;
  try {
    
  var tag = document.createElement('script');
  tag.src = "https://www.youtube.com/iframe_api";
  var firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  var player;
  function onYouTubeIframeAPIReady() {
    player = new YT.Player('hero-video', {
      events: {
        'onReady': onPlayerReady
      }
    });
  }

  function onPlayerReady(event) {
    var btn = document.getElementById('video-control');
    if (btn) {
      btn.addEventListener('click', function () {
        var state = player.getPlayerState();
        if (state === YT.PlayerState.PLAYING) {
          player.pauseVideo();
          btn.textContent = 'Play';
          btn.setAttribute('aria-label', 'Play video');
        } else {
          player.playVideo();
          btn.textContent = 'Pause';
          btn.setAttribute('aria-label', 'Pause video');
        }
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    const toggleButton = document.querySelector('.transcript-toggle');
    const transcript = document.getElementById('video-transcript-content');
  
    if (toggleButton && transcript) {
      toggleButton.addEventListener('click', () => {
        const isExpanded = toggleButton.getAttribute('aria-expanded') === 'true';
        toggleButton.setAttribute('aria-expanded', String(!isExpanded));
  
        if (isExpanded) {
          transcript.style.maxHeight = transcript.scrollHeight + 'px'; // ensure it's measurable
          transcript.classList.remove('open');
          requestAnimationFrame(() => {
            transcript.style.maxHeight = '0px';
          });
        } else {
          transcript.classList.add('open');
          transcript.hidden = false;
          transcript.style.maxHeight = '0px';
          requestAnimationFrame(() => {
            transcript.style.maxHeight = transcript.scrollHeight + 'px';
          });
        }
  
        // Al finalizar, limpiar el estilo para no fijarlo
        transcript.addEventListener('transitionend', () => {
          if (!isExpanded) {
            transcript.style.maxHeight = 'none';
          } else {
            transcript.hidden = true;
          }
        }, { once: true });
      });
    }
  });



  } catch(e) { console.error(e); }
})();
})();
